module.exports = __webpack_public_path__ + "static/media/logo.2406433e.svg";